const AGENT_GENERIC_ERROR =
  "We couldn't complete that request. Try again in a moment, or refresh the page if the problem continues.";

export function adminAgentFriendlyErrorMessage(raw: string | undefined): string {
  if (!raw?.trim()) return 'Something went wrong. Please try again.';

  let text = raw.trim();
  if (text.startsWith('{')) {
    try {
      const parsed = JSON.parse(text) as { error?: string; message?: string };
      text = (parsed.error || parsed.message || '').trim();
      if (!text) return AGENT_GENERIC_ERROR;
    } catch {
      return AGENT_GENERIC_ERROR;
    }
  }

  const lower = text.toLowerCase();
  if (lower.includes('failed to fetch') || lower.includes('networkerror') || lower.includes('load failed')) {
    return "Couldn't reach the agent — check your connection and try again.";
  }
  if (
    lower.includes('401') ||
    lower.includes('unauthorized') ||
    lower.includes('access token') ||
    lower.includes('invalid or expired') ||
    lower.includes('sign out and sign in') ||
    lower.includes('propelauth') ||
    lower.includes('jwt') ||
    lower.includes('kintsugi api rejected this session')
  ) {
    return "We couldn't verify your session. Try your request again — if it keeps failing, refresh the page.";
  }
  if (lower.includes('403') || lower.includes('forbidden') || lower.includes('not allowed to access')) {
    return "You don't have access to that. If this is unexpected, contact your Kintsugi admin.";
  }
  if (lower.includes('429') || lower.includes('rate limit')) {
    return 'Too many requests — please wait a moment and try again.';
  }
  if (
    lower.includes('500') ||
    lower.includes('502') ||
    lower.includes('503') ||
    lower.includes('504') ||
    lower.includes('internal server') ||
    lower.includes('service unavailable')
  ) {
    return 'The agent is temporarily unavailable. Please try again in a moment.';
  }

  return AGENT_GENERIC_ERROR;
}
